import Vue from 'vue';

// // Form Component
Vue.component('text-field', () =>
  import(
    /* webpackChunkName: "text-field" */ '@/components/Form/TextField.vue'
  ),
);
Vue.component('data-table-field', () =>
  import(
    /* webpackChunkName: "data-table-field" */ '@/components/Form/DataTableField.vue'
  ),
);
Vue.component('data-table-dialog', () =>
  import(
    /* webpackChunkName: "data-table-dialog" */ '@/components/DialogDataTable.vue'
  ),
);
Vue.component('location-field', () =>
  import(
    /* webpackChunkName: "location-field" */ '@/components/Form/LocationField.vue'
  ),
);
Vue.component('select-field', () =>
  import(
    /* webpackChunkName: "select-field" */ '@/components/Form/SelectField.vue'
  ),
);
Vue.component('textarea-field', () =>
  import(
    /* webpackChunkName: "textarea-field" */ '@/components/Form/TextareaField.vue'
  ),
);
Vue.component('autocomplete-field', () =>
  import(
    /* webpackChunkName: "autocomplete-field" */ '@/components/Form/AutocompleteField.vue'
  ),
);
Vue.component('combobox-field', () =>
  import(
    /* webpackChunkName: "combobox-field" */ '@/components/Form/ComboboxField.vue'
  ),
);
// End Form Component
Vue.component('data-table-header', () =>
  import(
    /* webpackChunkName: "data-table-header" */ '@/components/DataTableHeader.vue'
  ),
);
Vue.component('app-flash-message', () =>
  import(
    /* webpackChunkName: "app-flash-message" */ '@/components/AppFlashMessage.vue'
  ),
);
Vue.component('chip-status', () =>
  import(/* webpackChunkName: "chip-status" */ '@/components/ChipStatus.vue'),
);
